import { createRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";
import type { AnyRoute } from "@tanstack/react-router";

export const createMarketingRoutes = (parent: AnyRoute) => [
  createRoute({
    getParentRoute: () => parent,
    path: "/marketing/promo",
    component: lazyRouteComponent(() => import("pages/marketing/promo")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/marketing/advertisement",
    component: lazyRouteComponent(
      () => import("pages/marketing/advertisement"),
    ),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/marketing/advertisement/$id",
    component: lazyRouteComponent(
      () => import("pages/marketing/advertisement/id"),
    ),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/marketing/campaign",
    beforeLoad: () => {
      throw redirect({ to: "/marketing/advertisement" });
    },
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/marketing/advertisement_material",
    beforeLoad: () => {
      throw redirect({ to: "/marketing/advertisement" });
    },
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/marketing/advertisement_material_submission",
    beforeLoad: () => {
      throw redirect({ to: "/marketing/advertisement" });
    },
  }),
];
